import {gql} from 'apollo-boost';

export const GET_PROJECTS = gql`
  query getProjects{
    getProjects {
      id
      nameLocal
      nameEng
    }
  }
`;

export const GET_PROJECT = gql`
  query getProject($id : ID!){
    getProject (
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const ADD_PROJECT = gql`
  mutation addProject(
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    addProject(
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const UPDATE_PROJECT = gql`
  mutation updateProject(
    $id: ID!,
    $nameLocal: String!,
    $nameEng: String!,
  ) {
    updateProject(
      id: $id
      nameLocal: $nameLocal
      nameEng: $nameEng
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

export const DELETE_PROJECT = gql`
  mutation deleteProject($id: ID!) {
    deleteProject(
      id: $id
    ) {
      id
      nameLocal
      nameEng
    }
  }
`;

